import { render } from "./ProviderTeamAccordion.vue?vue&type=template&id=9cb2ea7c&scoped=true"
import script from "./ProviderTeamAccordion.vue?vue&type=script&lang=js"
export * from "./ProviderTeamAccordion.vue?vue&type=script&lang=js"

import "./ProviderTeamAccordion.vue?vue&type=style&index=0&id=9cb2ea7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cb2ea7c"]])

export default __exports__